module.exports = __webpack_public_path__ + "img/calendario.a55d2935.svg";